/**
 * クッキーのキーから値を取得
 * @param path
 */
export const getCookie = (path: String) => {
  var cookies = document.cookie //全てのcookieを取り出して
  var cookiesArray = cookies.split(';') // ;で分割し配列に

  for (var c of cookiesArray) {
    //一つ一つ取り出して
    var cArray = c.split('=') //さらに=で分割して配列に
    if (cArray[0].trim() === path) {
      // 取り出したいkeyと合致したら
      return cArray[1]
    }
  }
  return 'not found'
}

/**
 * ログインの期限が切れる時間（秒）
 */
export const LOGIN_EXPIRE_TIME = 60 * 20

/**
 * サイト名
 */
export const SITE_NAME = 'Goolip SP'

/**
 * ステータス
 */
export const STATUS = {
  project: [
    {
      id: 1,
      label: '見積中',
    },
    {
      id: 2,
      label: '見積破棄',
    },
    {
      id: 3,
      label: '受注',
    },
    {
      id: 4,
      label: '失注',
    },
    {
      id: 5,
      label: '売上',
    },
    {
      id: 6,
      label: '仮売上',
    },
  ],
  purchase: [
    {
      id: 1,
      label: '発注',
    },
    {
      id: 2,
      label: '発注済',
    },
    {
      id: 3,
      label: '発注破棄',
    },
    {
      id: 4,
      label: '仕入',
    },
  ],
}

/**
 * 型：ログインに必要な情報
 */
export interface typeLogin {
  login_id: string
  password: string
}

/**
 * APIのドメイン
 */
export const API_DOMAIN = () => {
  // TODO: 今後対象ドメインが増えることを想定し、配列として定義しておく
  if (['www.goolip.jp'].indexOf(window.location.hostname) !== -1) {
    //本番環境の場合
    return 'https://manage.goolip.jp'
  } else {
    //本番以外の環境の場合
    return 'http://staging.manage.goolip.jp'
  }
}

/**
 * 表示する文字数の限界(検索結果内)
 */
export const resultItemLengthLimit = 60

/**
 * 表示する文字数の限界(帳票のヘッダ内)
 */
export const formHeaderLengthLimit = 60

/**
 * 表示する文字数の限界を超えている場合、三点リーダをつける
 * @param text 元の文字列
 * @param limit 文字数の限界
 * @returns 出力する文字列
 */
export const stringLimited = (text:String|Number,limit:number) => {
  if (String(text).length > limit) {
    return String(text).substr(0,limit)+'...'
  } else {
    return text
  }
}

/**
 * 都道府県
 */
export const PREFECTURES = [
  { code: 1, name: '北海道' },
  { code: 2, name: '青森県' },
  { code: 3, name: '岩手県' },
  { code: 4, name: '宮城県' },
  { code: 5, name: '秋田県' },
  { code: 6, name: '山形県' },
  { code: 7, name: '福島県' },
  { code: 8, name: '茨城県' },
  { code: 9, name: '栃木県' },
  { code: 10, name: '群馬県' },
  { code: 11, name: '埼玉県' },
  { code: 12, name: '千葉県' },
  { code: 13, name: '東京都' },
  { code: 14, name: '神奈川県' },
  { code: 15, name: '新潟県' },
  { code: 16, name: '富山県' },
  { code: 17, name: '石川県' },
  { code: 18, name: '福井県' },
  { code: 19, name: '山梨県' },
  { code: 20, name: '長野県' },
  { code: 21, name: '岐阜県' },
  { code: 22, name: '静岡県' },
  { code: 23, name: '愛知県' },
  { code: 24, name: '三重県' },
  { code: 25, name: '滋賀県' },
  { code: 26, name: '京都府' },
  { code: 27, name: '大阪府' },
  { code: 28, name: '兵庫県' },
  { code: 29, name: '奈良県' },
  { code: 30, name: '和歌山県' },
  { code: 31, name: '鳥取県' },
  { code: 32, name: '島根県' },
  { code: 33, name: '岡山県' },
  { code: 34, name: '広島県' },
  { code: 35, name: '山口県' },
  { code: 36, name: '徳島県' },
  { code: 37, name: '香川県' },
  { code: 38, name: '愛媛県' },
  { code: 39, name: '高知県' },
  { code: 40, name: '福岡県' },
  { code: 41, name: '佐賀県' },
  { code: 42, name: '長崎県' },
  { code: 43, name: '熊本県' },
  { code: 44, name: '大分県' },
  { code: 45, name: '宮崎県' },
  { code: 46, name: '鹿児島県' },
  { code: 47, name: '沖縄県' },
]

/**
 * キーからクエリパラメータを取得
 * @param  name {string} パラメータのキー文字列
 * @return  url {url} 対象のURL文字列（任意）
 */
export function getParam(name: string, url: string) {
  if (!url) url = window.location.href
  name = name.replace(/[\[\]]/g, '\\$&')
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

/**
 * 権限に関する設定
 * project_management_permission: 案件管理 1:RW 2:RO 9:Not
 * order_management_permission: 発注管理 1:RW 2:RO 9:Not
 * purchase_management_permission: 仕入れ管理 1:RW 2:RO 9:Not
 * property_management_flag: 物件管理フラグ 0:off 1:on
 * plan_id: プランID 1:ミニマム 2:ベーシック 3:スタンダード 4:プレミアム
 */

export type Authority = {
  project_management_permission: 1 | 2 | 9
  order_management_permission: 1 | 2 | 9
  purchase_management_permission: 1 | 2 | 9
  property_management_flag: 0 | 1
  plan_id: 1 | 2 | 3 | 4
}

// 画面にアクセス不可（共通フッターでクリック不可）条件
const notDisplayPageCondition = {
  project: {
    project_management_permission: [9],
  },
  purchase: {
    order_management_permission: [9],
    plan_id: [1, 2, 3],
  },
  property: {
    property_management_flag: [0],
  },
}

// 案件非表示
// 設定の値を含んでいるかを判定し、含んでいればtrueを返す（非表示に）
export const isHiddenProject = (id: number) => {
  return notDisplayPageCondition.project.project_management_permission.includes(
    id,
  )
}

// 購買非表示
// 設定の値を含んでいるかを判定し、含んでいればtrueを返す（非表示に）
export const isHiddenPurChase = (
  orderManagementPermissionId: number,
  planId: number,
) => {
  return (
    notDisplayPageCondition.purchase.plan_id.includes(planId) ||
    notDisplayPageCondition.purchase.order_management_permission.includes(
      orderManagementPermissionId,
    )
  )
}

// 物件非表示
// 設定の値を含んでいるかを判定し、含んでいればtrueを返す（非表示に）
export const isHiddenProperty = (id: number) => {
  return notDisplayPageCondition.property.property_management_flag.includes(id)
}
